import { render } from "./FloorPlan.vue?vue&type=template&id=38dc1ef4&scoped=true"
import script from "./FloorPlan.vue?vue&type=script&lang=js"
export * from "./FloorPlan.vue?vue&type=script&lang=js"

import "./FloorPlan.vue?vue&type=style&index=0&id=38dc1ef4&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dc1ef4"]])

export default __exports__